import { useAuthContext } from "providers/Auth";
import { FEATURES } from "types/landlord/partner";

export const usePremiumWarningsReportEnabled = () => {
  const { partner } = useAuthContext();

  return Boolean(
    partner?.features.includes(FEATURES.UI_WIP_PREMIUM_WARNING_REPORT)
  );
};
